// this normalizes the url passed to a relative path for, intended for history and iframe navigation usage
// http://localhost:4000/project-management -> /project-management
export const normalizeUrl = (url: string) => {
  if (!url) return url

  try {
    const parsed = new URL(url, window.location.origin)
    return parsed.pathname + parsed.search + parsed.hash
  } catch {
    return url
  }
}
